// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"c3a96e43","63":"5f5d3735","66":"27310e0b","67":"93c4ffa1","151":"58d9dcde","329":"7e8bb436","361":"9f44561e","471":"777c3624","533":"a8817a4a","552":"0057c1c4","624":"e001a55e","822":"5a6a3676","936":"8916d42f","953":"d929f137"}[chunkId] + ".chunk.js";
};